import { SunlowerMark } from "@/components/brand/SunlowerMark";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/kit";

export function SidebarBrand() {
  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <SidebarMenuButton
          size="lg"
          className="cursor-default hover:bg-transparent active:bg-transparent"
        >
          <div className="flex aspect-square size-10 items-center justify-center rounded-xl bg-primary text-primary-foreground shadow-sm ring-1 ring-secondary/30">
            <SunlowerMark className="size-7" />
          </div>
          <div className="grid flex-1 text-start leading-tight">
            <span className="truncate font-display text-foreground text-lg leading-none">
              Sunlower
            </span>
            <span className="truncate font-sans font-semibold text-[10px] text-secondary uppercase tracking-[0.18em]">
              Admin · Supplies
            </span>
          </div>
        </SidebarMenuButton>
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
